import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonComponent } from '@components/common.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [RouterLink, NgIf],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent extends CommonComponent {}
